import { ButtonConfig } from '@ardoq/view-settings';
import { ButtonIcon } from './ButtonIcon';

const NewerOptionButton = ({
  id,
  label,
  iconName,
  onClick,
  isDisabled = false,
  isActive,
  popoverText,
  ariaLabel,
}: ButtonConfig) => (
  <ButtonIcon
    iconName={iconName}
    isActive={isActive}
    onClick={onClick}
    isDisabled={isDisabled}
    data-test-id={id}
    label={label}
    data-tooltip-text={popoverText ? undefined : label}
    popoverText={popoverText}
    aria-label={ariaLabel}
  />
);

export { NewerOptionButton };
